import { useEffect, useState } from 'react'
import { Link, Outlet } from 'react-router-dom'
import AccountMenu from '../../components/AccountMenu'
import { media } from '../content/media'
import { manualUi } from '../i18n/messages'
import { useManualLocale } from '../i18n/LocaleContext'
import { LanguageSwitch } from './LanguageSwitch'
import { ThemeToggle } from './ThemeToggle'
import { SearchDialog } from './SearchDialog'
import { Sidebar } from './Sidebar'
import '../manual.css'

export function Layout() {
  const { locale } = useManualLocale()
  const ui = manualUi(locale)
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [searchOpen, setSearchOpen] = useState(false)

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault()
        setSearchOpen(true)
      }
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [])

  return (
    <div className="xt-manual">
    <div className="app-shell">
      <div className="bg-atmosphere" aria-hidden="true" />
      <header className="mobile-bar">
        <button
          type="button"
          className="menu-btn"
          aria-label={ui.openNavigation}
          onClick={() => setSidebarOpen(true)}
        >
          <span />
          <span />
          <span />
        </button>
        <div className="mobile-title">
          <img className="mobile-logo" src={media.sepmLogo} alt="" width={28} height={28} />
          <span>
            <span className="brand-sepm">SEPM</span> X-Translator
          </span>
        </div>
        <LanguageSwitch />
        <ThemeToggle />
        <button type="button" className="icon-btn" onClick={() => setSearchOpen(true)}>
          {ui.search}
        </button>
      </header>

      {sidebarOpen ? (
        <button
          type="button"
          className="sidebar-backdrop"
          aria-label={ui.closeNavigation}
          onClick={() => setSidebarOpen(false)}
        />
      ) : null}

      <Sidebar
        open={sidebarOpen}
        onNavigate={() => setSidebarOpen(false)}
        onOpenSearch={() => {
          setSidebarOpen(false)
          setSearchOpen(true)
        }}
      />

      <main className="main-pane">
        <div className="manual-topbar">
          <Link to="/">{ui.allDocs}</Link>
          <div className="topbar-actions">
            <LanguageSwitch />
            <ThemeToggle />
            <AccountMenu />
          </div>
        </div>
        <Outlet />
      </main>

      <SearchDialog open={searchOpen} onClose={() => setSearchOpen(false)} />
    </div>
    </div>
  )
}
